import React, { useState, useEffect, FC, JSX } from "react";
import { useAdmin } from "../../context/AdminContext";
import { CompanyVerificationStatus } from "../../types/api";
import CompanyManagementTable from "../../components/company/CompanyManagementTable";

const AllCompanies: FC = (): JSX.Element => {
  const {
    allCompanies,
    loadingState,
    errorState,
    fetchAllCompanies,
    updateCompanyVerificationStatus,
  } = useAdmin();
  const [filterStatus, setFilterStatus] = useState<
    CompanyVerificationStatus | "All"
  >("All");

  // useEffect(() => {
  //   fetchAllCompanies();
  // }, []);

  return (
    <CompanyManagementTable
      companies={allCompanies}
      loading={loadingState.allCompanies}
      error={errorState.allCompanies}
      onRefresh={fetchAllCompanies}
      onUpdateVerificationStatus={updateCompanyVerificationStatus}
      isAdminView={true} // Admin view
      pageTitle="All Companies"
      pageDescription="View and manage all registered companies on the platform"
      showFilter={true}
      filterStatus={filterStatus}
      setFilterStatus={setFilterStatus}
      showReviewGuidelines={false}
      showVerificationHistory={true}
    />
  );
};

export default AllCompanies;
